
import { EventProperties } from '@avo/interface/trigger-props';
import { AssistanceSearchResult } from '@shared/travel-assistance/entities/booking-assistance';

export function assistanceSearchAmplitudePropsMapper(result: AssistanceSearchResult): EventProperties {
  if (result) {
    const plan = result?.Plans?.[0];
    const props = {
      PLAN_CODE: plan?.PlanCode,
      PLAN_NAME: plan?.PlanName,
      UNIT_PRICE: plan?.UnitPrice,
      VENDOR_NAME: result?.VendorName,
    };
    return props;
  } else return {};
}
